import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Photos from "../pages/Photos";
import Productions from "../pages/Productions";
import ProductionDetails from "../pages/Productions/ProductionDetails";
import Videos from "../pages/Videos";
import News from "../pages/News";
import NewsDetails from "../pages/News/NewsDetails";
import useSiteContent from "../context";
import Topbar from "../components/TopBar";
import Footer from "../components/Footer";
import PageDefault from "../pages/PageDefault";
import Loading from "../components/Loading";

export default function Routes() {
  const { siteContent } = useSiteContent();

  if (!siteContent) {
    return (
      <Loading />
    );
  }

  const pages = siteContent?.page?.filter(i => (
    !i.slug?.includes("noticias") && !i.slug?.includes("videos") && !i.slug?.includes("producoes") && !i.slug?.includes("fotos")
  ))
  const newsPage = siteContent?.page?.find(i => i.slug?.includes("noticias"))
  const news = siteContent?.information
  const videosPage = siteContent?.page?.find(i => i.slug?.includes("videos"))
  const videos = siteContent?.video
  const imagesPage = siteContent?.page?.find(i => i.slug?.includes("fotos"))
  const images = siteContent?.image
  const productionsPage = siteContent?.page?.find(i => i.slug?.includes("producoes"))
  const productions = siteContent?.production

  return (
    <div>
      <Topbar siteContent={siteContent} />
      <Switch>
        <Route exact path="/noticias/:id">
          <NewsDetails siteContent={{ ...newsPage, news }} />
        </Route>
        <Route exact path="/noticias">
          <News siteContent={{ ...newsPage, news }} />
        </Route>
        <Route exact path="/">
          <Home siteContent={siteContent} />
        </Route>
        {pages?.map(page => (
          <Route key={page?.slug} exact path={`/${page?.slug}`}>
            <PageDefault siteContent={page} />
          </Route>
        ))}
        <Route exact path="/fotos">
          <Photos siteContent={{ ...imagesPage, images }} />
        </Route>
        <Route exact path="/videos">
          <Videos siteContent={{ ...videosPage, videos }} />
        </Route>
        {productions.lenght !== 0 && (
          <>
            <Route exact path="/producoes">
              <Productions siteContent={{ ...productionsPage, productions }} />
            </Route>
            <Route exact path="/producoes/:id">
              <ProductionDetails siteContent={{ ...productionsPage, productions }} />
            </Route>
          </>
        )}
        <Route path="*" component={NotFound} />
      </Switch>
      <Footer />
    </div>
  )
}
